import { toString, FSharpRef, Record, Union } from "./fable_modules/fable-library.4.10.0/Types.js";
import { AdminModels_TourControlCard__get_IsSingleMultipart, AdminModels_TourControlCard__get_IsReadyForCountdown, AdminModels_TourControlCard__get_NeedToDisplayQuestion, AdminModels_TourControlCard__get_NeedToDisplayMedia, AdminModels_TourControlCard__SecondsLeft_7F9DDECF, QwKey, Slip__get_Annotation, TourStatus, SlipAnswer, SingleSlip__SetQwText, SingleSlip, Question as Question_1, QuizStatus_$reflection, QuizStatus, AdminModels_TourControlCard__IsCoundownActive_7F9DDECF, Slip as Slip_2, AdminModels_TourControlCard, Slip__get_Caption, PackageCard__GetSlip_Z524259A4, AdminModels_QuizControlCard, QwKey_$reflection, PackageCard_$reflection, PackageRecord_$reflection, RESP$1_$reflection, AdminModels_QuizControlCard_$reflection } from "../shared/Shared.fs.js";
import { getRecordField, getUnionFields, isUnion, obj_type, getRecordElements, makeUnion, name as name_1, getUnionCases, record_type, option_type, union_type, bool_type, int32_type, list_type, class_type, string_type } from "./fable_modules/fable-library.4.10.0/Reflection.js";
import { indexed, sortBy, reverse, singleton as singleton_1, ofArray, mapIndexed, length } from "./fable_modules/fable-library.4.10.0/List.js";
import { empty, FSharpMap__Remove, FSharpMap__Add } from "./fable_modules/fable-library.4.10.0/Map.js";
import { newGuid } from "./fable_modules/fable-library.4.10.0/Guid.js";
import { trimEnd, trimMiddle, ofDecimal, serverTime, timeoutCmd, timeDiff as timeDiff_1, noCmd, apiCmd } from "./Common.fs.js";
import { parse, tryParse } from "./fable_modules/fable-library.4.10.0/Int32.js";
import { value as value_4, defaultArg, unwrap } from "./fable_modules/fable-library.4.10.0/Option.js";
import { Cmd_batch } from "./fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { int32ToString, defaultOf, comparePrimitives, equals } from "./fable_modules/fable-library.4.10.0/Util.js";
import { tryFind, equalsWith } from "./fable_modules/fable-library.4.10.0/Array.js";
import { toString as toString_1, parse as parse_1 } from "./fable_modules/fable-library.4.10.0/Decimal.js";
import { FSharpResult$2 } from "./fable_modules/fable-library.4.10.0/Choice.js";
import { collect, append, map, empty as empty_1, singleton, delay, toList } from "./fable_modules/fable-library.4.10.0/Seq.js";
import * as react from "react";
import { DOMAttr, HTMLAttr } from "./fable_modules/Fable.React.9.4.0/Fable.React.Props.fs.js";
import { Internal_updateInputValue } from "./fable_modules/Fable.Elmish.React.5.0.0/./common.fs.js";
import { keyValueList } from "./fable_modules/fable-library.4.10.0/MapUtil.js";
import { Fa_IconOption, Fa_i } from "./fable_modules/Fable.FontAwesome.3.0.0/FontAwesome.fs.js";
import { printf, toText } from "./fable_modules/fable-library.4.10.0/String.js";
import { mediaEl } from "./MainTemplates.fs.js";
import { rangeDouble } from "./fable_modules/fable-library.4.10.0/Range.js";
import { Helpers_classList } from "./fable_modules/Fable.React.9.4.0/Fable.React.Helpers.fs.js";

export class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["QuizCardResp", "DeleteError", "Exn", "ChangeStatus", "ChangeStreamUrl", "PackagesClick", "PackagesResp", "SelectPackage", "PackagesCardResp", "SelectSlipIdx", "UpdateTourName", "UpdateTourSeconds", "UpdateSlipName", "UpdateQwText", "UpdateQwTextPart", "UpdateQwAnswer", "UpdateQwComment", "UpdateQwPoints", "UpdateQwJpdPoints", "UpdateQwWithChoice", "UpdateQwEOT", "NextQw", "NextQwPart", "DisplayMedia", "DisplayQw", "Start", "Tick", "Pause", "Settle", "NextSlip"];
    }
}

export function Msg_$reflection() {
    return union_type("AdminCP.Msg", [], Msg, () => [[["Item", RESP$1_$reflection(AdminModels_QuizControlCard_$reflection())]], [["Item", string_type]], [["Item", class_type("System.Exception")]], [["Item", string_type]], [["Item", string_type]], [], [["Item", RESP$1_$reflection(list_type(PackageRecord_$reflection()))]], [["Item", string_type]], [["Item", RESP$1_$reflection(PackageCard_$reflection())]], [["Item", string_type]], [["Item", string_type]], [["Item", string_type]], [["Item", string_type]], [["key", QwKey_$reflection()], ["txt", string_type]], [["key", QwKey_$reflection()], ["partIdx", int32_type], ["txt", string_type]], [["key", QwKey_$reflection()], ["txt", string_type]], [["key", QwKey_$reflection()], ["txt", string_type]], [["key", QwKey_$reflection()], ["txt", string_type]], [["key", QwKey_$reflection()], ["txt", string_type]], [["key", QwKey_$reflection()], ["Item2", bool_type]], [["key", QwKey_$reflection()], ["Item2", bool_type]], [], [], [], [], [], [], [], [], []]);
}

export class Model extends Record {
    constructor(Errors, Quiz, Package, AvailablePackages, IsLoading, TimeDiff) {
        super();
        this.Errors = Errors;
        this.Quiz = Quiz;
        this.Package = Package;
        this.AvailablePackages = AvailablePackages;
        this.IsLoading = IsLoading;
        this.TimeDiff = TimeDiff;
    }
}

export function Model_$reflection() {
    return record_type("AdminCP.Model", [], Model, () => [["Errors", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [string_type, string_type])], ["Quiz", option_type(AdminModels_QuizControlCard_$reflection())], ["Package", option_type(PackageCard_$reflection())], ["AvailablePackages", option_type(list_type(PackageRecord_$reflection()))], ["IsLoading", bool_type], ["TimeDiff", class_type("System.TimeSpan")]]);
}

export function Model__get_IsLastSlip(x) {
    let qwIdx;
    const matchValue = x.Quiz;
    const matchValue_1 = x.Package;
    let matchResult, pkg, quiz;
    if (matchValue != null) {
        if (matchValue_1 != null) {
            matchResult = 0;
            pkg = matchValue_1;
            quiz = matchValue;
        }
        else {
            matchResult = 1;
        }
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0: {
            const matchValue_3 = quiz.PackageId;
            const matchValue_4 = quiz.PackageSlipIdx;
            let matchResult_1, pkgId_1, qwIdx_1;
            if (matchValue_3 != null) {
                if (matchValue_4 != null) {
                    if ((qwIdx = (matchValue_4 | 0), matchValue_3 === pkg.PackageId)) {
                        matchResult_1 = 0;
                        pkgId_1 = matchValue_3;
                        qwIdx_1 = matchValue_4;
                    }
                    else {
                        matchResult_1 = 1;
                    }
                }
                else {
                    matchResult_1 = 1;
                }
            }
            else {
                matchResult_1 = 1;
            }
            switch (matchResult_1) {
                case 0:
                    return qwIdx_1 === (length(pkg.Slips) - 1);
                default:
                    return false;
            }
        }
        default:
            return false;
    }
}

export function addError(txt, model) {
    let copyOfStruct;
    return new Model(FSharpMap__Add(model.Errors, (copyOfStruct = newGuid(), copyOfStruct), txt), model.Quiz, model.Package, model.AvailablePackages, model.IsLoading, model.TimeDiff);
}

export function delError(id, model) {
    return new Model(FSharpMap__Remove(model.Errors, id), model.Quiz, model.Package, model.AvailablePackages, model.IsLoading, model.TimeDiff);
}

export function loading(model) {
    return new Model(model.Errors, model.Quiz, model.Package, model.AvailablePackages, true, model.TimeDiff);
}

export function editing(model) {
    return new Model(model.Errors, model.Quiz, model.Package, model.AvailablePackages, false, model.TimeDiff);
}

export function uploadPackages(api, model) {
    const matchValue = model.AvailablePackages;
    if (matchValue == null) {
        return apiCmd(api.getPackages, void 0, (Item) => (new Msg(6, [Item])), (Item_1) => (new Msg(2, [Item_1])), loading(model));
    }
    else {
        const pkgs = matchValue;
        return noCmd(model);
    }
}

export function setPackage(api, txt, model) {
    let matchValue;
    let outArg = 0;
    matchValue = [tryParse(txt, 511, false, 32, new FSharpRef(() => outArg, (v) => {
        outArg = (v | 0);
    })), outArg];
    if (matchValue[0]) {
        const id = matchValue[1] | 0;
        return apiCmd(api.setPackage, {
            PackageId: unwrap((id !== -1) ? id : void 0),
        }, (Item) => (new Msg(0, [Item])), (Item_1) => (new Msg(2, [Item_1])), loading(model));
    }
    else {
        return noCmd(model);
    }
}

export function setSlipIdx(txt, model) {
    let matchValue;
    let outArg = 0;
    matchValue = [tryParse(txt, 511, false, 32, new FSharpRef(() => outArg, (v) => {
        outArg = (v | 0);
    })), outArg];
    if (matchValue[0]) {
        const id = matchValue[1] | 0;
        const matchValue_1 = model.Package;
        if (matchValue_1 == null) {
            return model;
        }
        else {
            const pkg = matchValue_1;
            const model_2 = updateCard((q) => (new AdminModels_QuizControlCard(q.QuizStatus, q.PackageId, (id !== -1) ? id : void 0, q.CurrentTour, q.StreamUrl)), model);
            const matchValue_2 = PackageCard__GetSlip_Z524259A4(pkg, id);
            if (matchValue_2 == null) {
                return model_2;
            }
            else {
                const slip = matchValue_2;
                return updateTour((q_1) => (new AdminModels_TourControlCard((Slip__get_Caption(slip) !== "") ? Slip__get_Caption(slip) : q_1.Name, q_1.Seconds, q_1.Status, 0, 0, false, false, slip, q_1.StartTime)), model_2);
            }
        }
    }
    else {
        return model;
    }
}

export function setCard(api, card, st, model) {
    const model_1 = new Model(model.Errors, card, model.Package, model.AvailablePackages, model.IsLoading, timeDiff_1(st));
    const matchValue = model_1.Package;
    const matchValue_1 = card.PackageId;
    if (matchValue != null) {
        if (matchValue_1 == null) {
            return noCmd(editing(new Model(model_1.Errors, model_1.Quiz, void 0, model_1.AvailablePackages, model_1.IsLoading, model_1.TimeDiff)));
        }
        else if (matchValue.PackageId === matchValue_1) {
            const id_2 = matchValue_1 | 0;
            const pkg_1 = matchValue;
            return noCmd(editing(model_1));
        }
        else {
            const id_3 = matchValue_1 | 0;
            return apiCmd(api.getPackageCard, {
                PackageId: id_3,
            }, (Item_2) => (new Msg(8, [Item_2])), (Item_3) => (new Msg(2, [Item_3])), loading(new Model(model_1.Errors, model_1.Quiz, void 0, model_1.AvailablePackages, model_1.IsLoading, model_1.TimeDiff)));
        }
    }
    else if (matchValue_1 == null) {
        return noCmd(editing(model_1));
    }
    else {
        const id_1 = matchValue_1 | 0;
        return apiCmd(api.getPackageCard, {
            PackageId: id_1,
        }, (Item) => (new Msg(8, [Item])), (Item_1) => (new Msg(2, [Item_1])), loading(model_1));
    }
}

export function updateCard(f, model) {
    const matchValue = model.Quiz;
    if (matchValue != null) {
        return new Model(model.Errors, f(matchValue), model.Package, model.AvailablePackages, model.IsLoading, model.TimeDiff);
    }
    else {
        return model;
    }
}

export function updateTour(f, model) {
    const matchValue = model.Quiz;
    if (matchValue != null) {
        const quiz = matchValue;
        const matchValue_1 = quiz.CurrentTour;
        if (matchValue_1 == null) {
            return model;
        }
        else {
            return new Model(model.Errors, new AdminModels_QuizControlCard(quiz.QuizStatus, quiz.PackageId, quiz.PackageSlipIdx, f(matchValue_1), quiz.StreamUrl), model.Package, model.AvailablePackages, model.IsLoading, model.TimeDiff);
        }
    }
    else {
        return model;
    }
}

export function updateSlip(qwKey, f, model) {
    return updateTour((tour) => {
        let tupledArg;
        const matchValue = tour.Slip;
        if (matchValue.tag === 1) {
            return new AdminModels_TourControlCard(tour.Name, tour.Seconds, tour.Status, tour.QwIdx, tour.QwPartIdx, tour.IsMediaDisplayed, tour.IsQuestionDisplayed, (tupledArg = [matchValue.fields[0], mapIndexed((idx, slip_1) => {
                if (idx === qwKey.QwIdx) {
                    return f(slip_1);
                }
                else {
                    return slip_1;
                }
            }, matchValue.fields[1])], new Slip_2(1, [tupledArg[0], tupledArg[1]])), tour.StartTime);
        }
        else {
            return new AdminModels_TourControlCard(tour.Name, tour.Seconds, tour.Status, tour.QwIdx, tour.QwPartIdx, tour.IsMediaDisplayed, tour.IsQuestionDisplayed, new Slip_2(0, [f(matchValue.fields[0])]), tour.StartTime);
        }
    }, model);
}

export function scheduleTick(model, cmd) {
    const matchValue = model.Quiz;
    let matchResult, quiz_1;
    if (matchValue != null) {
        if (equals(matchValue.QuizStatus, new QuizStatus(1, []))) {
            matchResult = 0;
            quiz_1 = matchValue;
        }
        else {
            matchResult = 1;
        }
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0: {
            const matchValue_1 = quiz_1.CurrentTour;
            let matchResult_1, tour_1;
            if (matchValue_1 != null) {
                if (AdminModels_TourControlCard__IsCoundownActive_7F9DDECF(matchValue_1, serverTime(model.TimeDiff))) {
                    matchResult_1 = 0;
                    tour_1 = matchValue_1;
                }
                else {
                    matchResult_1 = 1;
                }
            }
            else {
                matchResult_1 = 1;
            }
            switch (matchResult_1) {
                case 0:
                    return [model, Cmd_batch(ofArray([cmd, timeoutCmd(new Msg(26, []), 1000)]))];
                default:
                    return [model, cmd];
            }
        }
        default:
            return [model, cmd];
    }
}

export function init(api, user) {
    return apiCmd(api.getQuizCard, void 0, (Item) => (new Msg(0, [Item])), (Item_1) => (new Msg(2, [Item_1])), new Model(empty({
        Compare: comparePrimitives,
    }), void 0, void 0, void 0, true, 0));
}

export function update(api, user, msg, cm) {
    let matchValue_3, array_3;
    let matchResult, id, res_3, st, txt_3, txt_4, pkgs, txt_5, txt_6, res_4, txt_7, txt_8, txt_9, key, txt_10, key_1, partIdx, txt_11, key_2, txt_13, key_3, txt_14, key_4, txt_15, key_5, txt_16, key_6, v, key_7, v_1, ex, txt_18;
    switch (msg.tag) {
        case 0: {
            if (msg.fields[0].Value.tag === 0) {
                matchResult = 1;
                res_3 = msg.fields[0].Value.fields[0];
                st = msg.fields[0].ST;
            }
            else {
                let activePatternResult;
                const msg_1 = msg;
                const pi_1 = tryFind((pi) => (name_1(pi) === "Value"), getRecordElements(RESP$1_$reflection(obj_type)));
                if (pi_1 == null) {
                    activePatternResult = void 0;
                }
                else {
                    const pi$0027 = pi_1;
                    let msgType;
                    let copyOfStruct = msg_1;
                    msgType = Msg_$reflection();
                    if (isUnion(msgType)) {
                        const objArray = getUnionFields(msg_1, msgType)[1];
                        if (objArray.length === 1) {
                            try {
                                const patternInput_1 = getUnionFields(getRecordField(objArray[0], pi$0027), union_type("Microsoft.FSharp.Core.FSharpResult`2", [obj_type, obj_type], FSharpResult$2, () => [[["ResultValue", obj_type]], [["ErrorValue", obj_type]]]));
                                activePatternResult = ((name_1(patternInput_1[0]) === "Error") ? patternInput_1[1][0] : void 0);
                            }
                            catch (matchValue) {
                                activePatternResult = void 0;
                            }
                        }
                        else {
                            activePatternResult = void 0;
                        }
                    }
                    else {
                        activePatternResult = void 0;
                    }
                }
                if (activePatternResult != null) {
                    matchResult = 30;
                    txt_18 = activePatternResult;
                }
                else {
                    matchResult = 31;
                }
            }
            break;
        }
        case 3: {
            matchResult = 2;
            txt_3 = msg.fields[0];
            break;
        }
        case 4: {
            matchResult = 3;
            txt_4 = msg.fields[0];
            break;
        }
        case 5: {
            matchResult = 4;
            break;
        }
        case 6: {
            if (msg.fields[0].Value.tag === 0) {
                matchResult = 5;
                pkgs = msg.fields[0].Value.fields[0];
            }
            else {
                let activePatternResult_1;
                const msg_2 = msg;
                const pi_1_1 = tryFind((pi_2) => (name_1(pi_2) === "Value"), getRecordElements(RESP$1_$reflection(obj_type)));
                if (pi_1_1 == null) {
                    activePatternResult_1 = void 0;
                }
                else {
                    const pi$0027_1 = pi_1_1;
                    let msgType_1;
                    let copyOfStruct_1 = msg_2;
                    msgType_1 = Msg_$reflection();
                    if (isUnion(msgType_1)) {
                        const objArray_2 = getUnionFields(msg_2, msgType_1)[1];
                        if (objArray_2.length === 1) {
                            try {
                                const patternInput_1_1 = getUnionFields(getRecordField(objArray_2[0], pi$0027_1), union_type("Microsoft.FSharp.Core.FSharpResult`2", [obj_type, obj_type], FSharpResult$2, () => [[["ResultValue", obj_type]], [["ErrorValue", obj_type]]]));
                                activePatternResult_1 = ((name_1(patternInput_1_1[0]) === "Error") ? patternInput_1_1[1][0] : void 0);
                            }
                            catch (matchValue_1) {
                                activePatternResult_1 = void 0;
                            }
                        }
                        else {
                            activePatternResult_1 = void 0;
                        }
                    }
                    else {
                        activePatternResult_1 = void 0;
                    }
                }
                if (activePatternResult_1 != null) {
                    matchResult = 30;
                    txt_18 = activePatternResult_1;
                }
                else {
                    matchResult = 31;
                }
            }
            break;
        }
        case 7: {
            matchResult = 6;
            txt_5 = msg.fields[0];
            break;
        }
        case 9: {
            matchResult = 7;
            txt_6 = msg.fields[0];
            break;
        }
        case 8: {
            if (msg.fields[0].Value.tag === 0) {
                matchResult = 8;
                res_4 = msg.fields[0].Value.fields[0];
            }
            else {
                let activePatternResult_2;
                const msg_3 = msg;
                const pi_1_2 = tryFind((pi_3) => (name_1(pi_3) === "Value"), getRecordElements(RESP$1_$reflection(obj_type)));
                if (pi_1_2 == null) {
                    activePatternResult_2 = void 0;
                }
                else {
                    const pi$0027_2 = pi_1_2;
                    let msgType_2;
                    let copyOfStruct_2 = msg_3;
                    msgType_2 = Msg_$reflection();
                    if (isUnion(msgType_2)) {
                        const objArray_3 = getUnionFields(msg_3, msgType_2)[1];
                        if (objArray_3.length === 1) {
                            try {
                                const patternInput_1_2 = getUnionFields(getRecordField(objArray_3[0], pi$0027_2), union_type("Microsoft.FSharp.Core.FSharpResult`2", [obj_type, obj_type], FSharpResult$2, () => [[["ResultValue", obj_type]], [["ErrorValue", obj_type]]]));
                                activePatternResult_2 = ((name_1(patternInput_1_2[0]) === "Error") ? patternInput_1_2[1][0] : void 0);
                            }
                            catch (matchValue_2) {
                                activePatternResult_2 = void 0;
                            }
                        }
                        else {
                            activePatternResult_2 = void 0;
                        }
                    }
                    else {
                        activePatternResult_2 = void 0;
                    }
                }
                if (activePatternResult_2 != null) {
                    matchResult = 30;
                    txt_18 = activePatternResult_2;
                }
                else {
                    matchResult = 31;
                }
            }
            break;
        }
        case 10: {
            matchResult = 9;
            txt_7 = msg.fields[0];
            break;
        }
        case 11: {
            matchResult = 10;
            txt_8 = msg.fields[0];
            break;
        }
        case 12: {
            matchResult = 11;
            txt_9 = msg.fields[0];
            break;
        }
        case 13: {
            matchResult = 12;
            key = msg.fields[0];
            txt_10 = msg.fields[1];
            break;
        }
        case 14: {
            matchResult = 13;
            key_1 = msg.fields[0];
            partIdx = msg.fields[1];
            txt_11 = msg.fields[2];
            break;
        }
        case 15: {
            matchResult = 14;
            key_2 = msg.fields[0];
            txt_13 = msg.fields[1];
            break;
        }
        case 16: {
            matchResult = 15;
            key_3 = msg.fields[0];
            txt_14 = msg.fields[1];
            break;
        }
        case 17: {
            matchResult = 16;
            key_4 = msg.fields[0];
            txt_15 = msg.fields[1];
            break;
        }
        case 18: {
            matchResult = 17;
            key_5 = msg.fields[0];
            txt_16 = msg.fields[1];
            break;
        }
        case 19: {
            matchResult = 18;
            key_6 = msg.fields[0];
            v = msg.fields[1];
            break;
        }
        case 20: {
            matchResult = 19;
            key_7 = msg.fields[0];
            v_1 = msg.fields[1];
            break;
        }
        case 21: {
            matchResult = 20;
            break;
        }
        case 22: {
            matchResult = 21;
            break;
        }
        case 23: {
            matchResult = 22;
            break;
        }
        case 24: {
            matchResult = 23;
            break;
        }
        case 25: {
            matchResult = 24;
            break;
        }
        case 26: {
            matchResult = 25;
            break;
        }
        case 27: {
            matchResult = 26;
            break;
        }
        case 28: {
            matchResult = 27;
            break;
        }
        case 29: {
            matchResult = 28;
            break;
        }
        case 2: {
            matchResult = 29;
            ex = msg.fields[0];
            break;
        }
        default: {
            matchResult = 0;
            id = msg.fields[0];
        }
    }
    switch (matchResult) {
        case 0:
            return noCmd(delError(id, cm));
        case 1: {
            const tupledArg = setCard(api, res_3, st, cm);
            return scheduleTick(tupledArg[0], tupledArg[1]);
        }
        case 2: {
            const model_5 = loading(cm);
            return apiCmd(api.changeQuizStatus, {
                QuizStatus: defaultArg((matchValue_3 = ((array_3 = getUnionCases(QuizStatus_$reflection()), array_3.filter((case$) => (name_1(case$) === txt_3)))), (!equalsWith(equals, matchValue_3, defaultOf()) && (matchValue_3.length === 1)) ? makeUnion(matchValue_3[0], []) : void 0), new QuizStatus(0, [])),
            }, (Item) => (new Msg(0, [Item])), (Item_1) => (new Msg(2, [Item_1])), model_5);
        }
        case 3:
            return apiCmd(api.changeStreamUrl, txt_4, (Item_2) => (new Msg(0, [Item_2])), (Item_3) => (new Msg(2, [Item_3])), loading(cm));
        case 4:
            return uploadPackages(api, cm);
        case 5:
            return noCmd(editing(new Model(cm.Errors, cm.Quiz, cm.Package, pkgs, cm.IsLoading, cm.TimeDiff)));
        case 6:
            return setPackage(api, txt_5, cm);
        case 7:
            return noCmd(setSlipIdx(txt_6, cm));
        case 8:
            return noCmd(editing(new Model(cm.Errors, cm.Quiz, res_4, cm.AvailablePackages, cm.IsLoading, cm.TimeDiff)));
        case 9:
            return noCmd(updateTour((qw) => (new AdminModels_TourControlCard(txt_7, qw.Seconds, qw.Status, qw.QwIdx, qw.QwPartIdx, qw.IsMediaDisplayed, qw.IsQuestionDisplayed, qw.Slip, qw.StartTime)), cm));
        case 10:
            return noCmd(updateTour((qw_1) => (new AdminModels_TourControlCard(qw_1.Name, parse(txt_8, 511, false, 32), qw_1.Status, qw_1.QwIdx, qw_1.QwPartIdx, qw_1.IsMediaDisplayed, qw_1.IsQuestionDisplayed, qw_1.Slip, qw_1.StartTime)), cm));
        case 11:
            return noCmd(updateTour((qw_2) => {
                let matchValue_4, tupledArg_1;
                return new AdminModels_TourControlCard(qw_2.Name, qw_2.Seconds, qw_2.Status, qw_2.QwIdx, qw_2.QwPartIdx, qw_2.IsMediaDisplayed, qw_2.IsQuestionDisplayed, (matchValue_4 = qw_2.Slip, (matchValue_4.tag === 1) ? ((tupledArg_1 = [txt_9, matchValue_4.fields[1]], new Slip_2(1, [tupledArg_1[0], tupledArg_1[1]]))) : qw_2.Slip), qw_2.StartTime);
            }, cm));
        case 12:
            return noCmd(updateSlip(key, (slip) => (new SingleSlip(slip.Caption, new Question_1(0, [txt_10]), slip.QuestionMedia, slip.Answer, slip.AnswerMedia, slip.Comment, slip.Points, slip.JeopardyPoints, slip.WithChoice, slip.Seconds, slip.EndOfTour)), cm));
        case 13:
            return noCmd(updateSlip(key_1, (slip_1) => SingleSlip__SetQwText(slip_1, partIdx, txt_11), cm));
        case 14:
            return noCmd(updateSlip(key_2, (slip_2) => (new SingleSlip(slip_2.Caption, slip_2.Question, slip_2.QuestionMedia, new SlipAnswer(0, [txt_13]), slip_2.AnswerMedia, slip_2.Comment, slip_2.Points, slip_2.JeopardyPoints, slip_2.WithChoice, slip_2.Seconds, slip_2.EndOfTour)), cm));
        case 15:
            return noCmd(updateSlip(key_3, (slip_3) => (new SingleSlip(slip_3.Caption, slip_3.Question, slip_3.QuestionMedia, slip_3.Answer, slip_3.AnswerMedia, txt_14, slip_3.Points, slip_3.JeopardyPoints, slip_3.WithChoice, slip_3.Seconds, slip_3.EndOfTour)), cm));
        case 16:
            return noCmd(updateSlip(key_4, (slip_4) => (new SingleSlip(slip_4.Caption, slip_4.Question, slip_4.QuestionMedia, slip_4.Answer, slip_4.AnswerMedia, slip_4.Comment, parse_1(txt_15), slip_4.JeopardyPoints, slip_4.WithChoice, slip_4.Seconds, slip_4.EndOfTour)), cm));
        case 17:
            return noCmd(updateSlip(key_5, (slip_5) => (new SingleSlip(slip_5.Caption, slip_5.Question, slip_5.QuestionMedia, slip_5.Answer, slip_5.AnswerMedia, slip_5.Comment, slip_5.Points, ofDecimal(txt_16), slip_5.WithChoice, slip_5.Seconds, slip_5.EndOfTour)), cm));
        case 18:
            return noCmd(updateSlip(key_6, (slip_6) => (new SingleSlip(slip_6.Caption, slip_6.Question, slip_6.QuestionMedia, slip_6.Answer, slip_6.AnswerMedia, slip_6.Comment, slip_6.Points, slip_6.JeopardyPoints, v, slip_6.Seconds, slip_6.EndOfTour)), cm));
        case 19:
            return noCmd(updateSlip(key_7, (slip_7) => (new SingleSlip(slip_7.Caption, slip_7.Question, slip_7.QuestionMedia, slip_7.Answer, slip_7.AnswerMedia, slip_7.Comment, slip_7.Points, slip_7.JeopardyPoints, slip_7.WithChoice, slip_7.Seconds, v_1)), cm));
        case 20: {
            const model_39 = loading(cm);
            return apiCmd(api.nextQuestion, value_4(cm.Quiz), (Item_6) => (new Msg(0, [Item_6])), (Item_7) => (new Msg(2, [Item_7])), model_39);
        }
        case 21: {
            const model_41 = loading(cm);
            return apiCmd(api.nextQuestionPart, value_4(cm.Quiz), (Item_8) => (new Msg(0, [Item_8])), (Item_9) => (new Msg(2, [Item_9])), model_41);
        }
        case 22: {
            const model_43 = loading(cm);
            return apiCmd(api.showMedia, value_4(cm.Quiz), (Item_10) => (new Msg(0, [Item_10])), (Item_11) => (new Msg(2, [Item_11])), model_43);
        }
        case 23: {
            const model_45 = loading(cm);
            return apiCmd(api.showQuestion, value_4(cm.Quiz), (Item_12) => (new Msg(0, [Item_12])), (Item_13) => (new Msg(2, [Item_13])), model_45);
        }
        case 24: {
            const model_47 = loading(cm);
            return apiCmd(api.startCountDown, value_4(cm.Quiz), (Item_14) => (new Msg(0, [Item_14])), (Item_15) => (new Msg(2, [Item_15])), model_47);
        }
        case 25: {
            const tupledArg_2 = noCmd(cm);
            return scheduleTick(tupledArg_2[0], tupledArg_2[1]);
        }
        case 26:
            return apiCmd(api.pauseCountDown, void 0, (Item_16) => (new Msg(0, [Item_16])), (Item_17) => (new Msg(2, [Item_17])), loading(cm));
        case 27:
            return apiCmd(api.settleTour, void 0, (Item_18) => (new Msg(0, [Item_18])), (Item_19) => (new Msg(2, [Item_19])), loading(cm));
        case 28:
            return apiCmd(api.nextTour, void 0, (Item_20) => (new Msg(0, [Item_20])), (Item_21) => (new Msg(2, [Item_21])), loading(cm));
        case 29:
            return noCmd(editing(addError(ex.message, cm)));
        case 30:
            return noCmd(editing(addError(txt_18, cm)));
        default:
            return noCmd(cm);
    }
}

export function view(dispatch, user, settings, model) {
    let children_2, children_6, children_4, children_12;
    const children_14 = [(children_2 = toList(delay(() => (model.IsLoading ? singleton(react.createElement("button", {
        className: "button is-loading is-large is-fullwidth is-light",
    })) : empty_1()))), react.createElement("div", {
        className: "column",
    }, ...children_2)), (children_6 = [(children_4 = toList(delay(() => {
        const matchValue = model.Quiz;
        if (matchValue == null) {
            return empty_1();
        }
        else {
            return singleton(quizView(dispatch, user, settings, model, matchValue));
        }
    })), react.createElement("div", {}, ...children_4))], react.createElement("div", {
        className: "column",
    }, ...children_6)), (children_12 = toList(delay(() => map((error) => {
        const children_10 = [react.createElement("button", {
            className: "delete",
            onClick: (_arg) => {
                dispatch(new Msg(1, [error[0]]));
            },
        }), error[1]];
        return react.createElement("div", {
            className: "notification is-danger is-light",
        }, ...children_10);
    }, model.Errors))), react.createElement("div", {
        className: "column",
    }, ...children_12))];
    return react.createElement("div", {
        className: "columns",
    }, ...children_14);
}

export function quizView(dispatch, user, settings, model, quiz) {
    let qw, children_16, children_8, children_6, props_4, value, children_4, children_14, children_12, props_12, children_50, children_52;
    let changesNotAllowed;
    const matchValue = quiz.CurrentTour;
    let matchResult, qw_1;
    if (matchValue != null) {
        if ((qw = matchValue, equals(qw.Status, new TourStatus(1, [])) ? true : equals(qw.Status, new TourStatus(2, [])))) {
            matchResult = 0;
            qw_1 = matchValue;
        }
        else {
            matchResult = 1;
        }
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0: {
            changesNotAllowed = true;
            break;
        }
        default:
            changesNotAllowed = false;
    }
    let isCountdown;
    const matchValue_1 = quiz.CurrentTour;
    let matchResult_1, qw_3;
    if (matchValue_1 != null) {
        if (equals(matchValue_1.Status, new TourStatus(1, []))) {
            matchResult_1 = 0;
            qw_3 = matchValue_1;
        }
        else {
            matchResult_1 = 1;
        }
    }
    else {
        matchResult_1 = 1;
    }
    switch (matchResult_1) {
        case 0: {
            isCountdown = true;
            break;
        }
        default:
            isCountdown = false;
    }
    const isReadOnly = changesNotAllowed ? true : model.IsLoading;
    const children_54 = [(children_16 = [(children_8 = [react.createElement("label", {
        className: "label",
    }, "Status"), (children_6 = [(props_4 = [new HTMLAttr(79, [model.IsLoading ? true : isCountdown]), (value = toString(quiz.QuizStatus), ["ref", (e) => {
        Internal_updateInputValue(value, e);
    }]), new DOMAttr(9, [(ev) => {
        dispatch(new Msg(3, [ev.target.value]));
    }])], (children_4 = toList(delay(() => map((case$) => {
        const children_2 = [name_1(case$)];
        return react.createElement("option", {}, ...children_2);
    }, getUnionCases(QuizStatus_$reflection())))), react.createElement("select", keyValueList(props_4, 1), ...children_4)))], react.createElement("div", {
        className: "select",
    }, ...children_6))], react.createElement("div", {
        className: "control",
    }, ...children_8)), (children_14 = [react.createElement("label", {
        className: "label",
    }, "Stream URL"), (children_12 = [(props_12 = [new HTMLAttr(65, ["input"]), new HTMLAttr(159, ["text"]), new HTMLAttr(115, [256]), new HTMLAttr(161, [defaultArg(quiz.StreamUrl, "")]), new DOMAttr(9, [(ev_1) => {
        dispatch(new Msg(4, [ev_1.target.value]));
    }])], react.createElement("input", keyValueList(props_12, 1)))], react.createElement("div", {
        className: "control is-expanded has-icons-right",
    }, ...children_12))], react.createElement("div", {
        className: "control is-expanded",
    }, ...children_14))], react.createElement("div", {
        className: "field is-grouped",
    }, ...children_16)), (children_50 = toList(delay(() => {
        let children_36;
        return append(singleton((children_36 = toList(delay(() => {
            const isControlReadOnly = (changesNotAllowed && !Model__get_IsLastSlip(model)) ? true : model.IsLoading;
            return append(singleton(react.createElement("label", {
                className: "label",
            }, "Questions Package")), delay(() => {
                let children_34, children_28, children_32, children_30, children_26;
                const matchValue_2 = model.AvailablePackages;
                if (matchValue_2 == null) {
                    return singleton((children_34 = [(children_28 = toList(delay(() => {
                        let txt;
                        const matchValue_4 = model.Package;
                        txt = ((matchValue_4 == null) ? "Not Selected" : matchValue_4.Name);
                        return singleton(react.createElement("input", {
                            className: "input",
                            type: "text",
                            value: txt,
                            readOnly: true,
                            maxLength: 32,
                        }));
                    })), react.createElement("div", {
                        className: "control",
                    }, ...children_28)), (children_32 = [(children_30 = [Fa_i(singleton_1(new Fa_IconOption(11, ["fas fa-ellipsis-h"])), [])], react.createElement("button", {
                        className: "button",
                        onClick: (_arg) => {
                            dispatch(new Msg(5, []));
                        },
                    }, ...children_30))], react.createElement("div", {
                        className: "control",
                    }, ...children_32))], react.createElement("div", {
                        className: "field has-addons",
                    }, ...children_34)));
                }
                else {
                    const pkgs = matchValue_2;
                    return singleton((children_26 = toList(delay(() => {
                        let children_24;
                        let value_2;
                        const matchValue_3 = model.Package;
                        value_2 = ((matchValue_3 == null) ? -1 : matchValue_3.PackageId);
                        return singleton((children_24 = toList(delay(() => append(singleton(react.createElement("option", {
                            value: -1,
                        }, "Not Selected")), delay(() => map((pkg_1) => {
                            const children_22 = [trimMiddle(32, "...", pkg_1.Name)];
                            return react.createElement("option", {
                                value: pkg_1.PackageId,
                            }, ...children_22);
                        }, reverse(sortBy((p) => p.PackageId, pkgs, {
                            Compare: comparePrimitives,
                        }))))))), react.createElement("select", {
                            disabled: isControlReadOnly,
                            value: value_2,
                            onChange: (ev_2) => {
                                dispatch(new Msg(7, [ev_2.target.value]));
                            },
                        }, ...children_24)));
                    })), react.createElement("div", {
                        className: "select",
                    }, ...children_26)));
                }
            }));
        })), react.createElement("div", {
            className: "control",
        }, ...children_36))), delay(() => {
            let children_48, children_46;
            if (quiz.CurrentTour == null) {
                return empty_1();
            }
            else {
                return singleton((children_48 = [react.createElement("label", {
                    className: "label",
                }, "Question"), (children_46 = toList(delay(() => {
                    let children_44;
                    let value_3;
                    const matchValue_6 = quiz.PackageSlipIdx;
                    value_3 = ((matchValue_6 == null) ? -1 : matchValue_6);
                    return singleton((children_44 = toList(delay(() => append(singleton(react.createElement("option", {
                        value: -1,
                    }, "Not Selected")), delay(() => {
                        const matchValue_7 = model.Package;
                        if (matchValue_7 == null) {
                            return empty_1();
                        }
                        else {
                            return collect((matchValue_8) => {
                                let children_42, arg, arg_1;
                                const idx_1 = matchValue_8[0] | 0;
                                return singleton((children_42 = [(arg = ((idx_1 + 1) | 0), (arg_1 = trimEnd(32, "...", Slip__get_Annotation(matchValue_8[1])), toText(printf("%i %s"))(arg)(arg_1)))], react.createElement("option", {
                                    value: idx_1,
                                }, ...children_42)));
                            }, mapIndexed((idx_2, slip_1) => [idx_2, slip_1], matchValue_7.Slips));
                        }
                    })))), react.createElement("select", {
                        disabled: isReadOnly,
                        value: value_3,
                        onChange: (ev_3) => {
                            dispatch(new Msg(9, [ev_3.target.value]));
                        },
                    }, ...children_44)));
                })), react.createElement("div", {
                    className: "select",
                }, ...children_46))], react.createElement("div", {
                    className: "control",
                }, ...children_48)));
            }
        }));
    })), react.createElement("div", {
        className: "field is-grouped",
    }, ...children_50)), (children_52 = toList(delay(() => {
        const matchValue_9 = quiz.CurrentTour;
        if (matchValue_9 == null) {
            return empty_1();
        }
        else {
            const qw_4 = matchValue_9;
            return append(singleton(react.createElement("hr", {
                className: "has-background-grey",
            })), delay(() => singleton(qwView(dispatch, user, settings, qw_4, model.TimeDiff, isReadOnly, model.IsLoading, Model__get_IsLastSlip(model)))));
        }
    })), react.createElement("div", {}, ...children_52))];
    return react.createElement("div", {}, ...children_54);
}

export function qwTextArea(dispatch, key, txt, isReadOnly) {
    let children_4;
    const children_6 = [react.createElement("label", {
        className: "label",
    }, "Question Text"), (children_4 = [react.createElement("textarea", {
        className: "textarea",
        disabled: isReadOnly,
        maxLength: 512,
        ref: (e) => {
            Internal_updateInputValue(txt, e);
        },
        onChange: (ev) => {
            dispatch(new Msg(13, [key, ev.target.value]));
        },
    })], react.createElement("div", {
        className: "control",
    }, ...children_4))];
    return react.createElement("div", {
        className: "field",
    }, ...children_6);
}

export function qwInput(dispatch, placeholder, txt, key, partIdx, anounced) {
    const props_6 = [new HTMLAttr(65, ["control has-icons-left has-icons-right"]), ["style", {
        marginBottom: "3px",
    }]];
    const children_4 = toList(delay(() => append(singleton(react.createElement("input", {
        className: "input",
        type: "text",
        placeholder: placeholder,
        readOnly: anounced,
        ref: (e) => {
            Internal_updateInputValue(txt, e);
        },
        maxLength: 256,
        onChange: (ev) => {
            dispatch(new Msg(14, [key, partIdx, ev.target.value]));
        },
    })), delay(() => {
        let children, arg;
        return append(singleton((children = [(arg = ((partIdx + 1) | 0), toText(printf("%i"))(arg))], react.createElement("span", {
            className: "icon is-left",
        }, ...children))), delay(() => {
            let children_2;
            return anounced ? singleton((children_2 = [Fa_i(singleton_1(new Fa_IconOption(11, ["fas fa-check"])), [])], react.createElement("span", {
                className: "icon is-right",
            }, ...children_2))) : empty_1();
        }));
    }))));
    return react.createElement("div", keyValueList(props_6, 1), ...children_4);
}

export function awTextArea(dispatch, key, txt, isReadOnly) {
    let children_4;
    const children_6 = [react.createElement("label", {
        className: "label",
    }, "Answer"), (children_4 = [react.createElement("textarea", {
        className: "textarea",
        disabled: isReadOnly,
        maxLength: 512,
        ref: (e) => {
            Internal_updateInputValue(txt, e);
        },
        onChange: (ev) => {
            dispatch(new Msg(15, [key, ev.target.value]));
        },
    })], react.createElement("div", {
        className: "control",
    }, ...children_4))];
    return react.createElement("div", {
        className: "field",
    }, ...children_6);
}

export function cmtTextArea(dispatch, key, txt, isReadOnly) {
    let children_4;
    const children_6 = [react.createElement("label", {
        className: "label",
    }, "Comment"), (children_4 = [react.createElement("textarea", {
        className: "textarea",
        disabled: isReadOnly,
        maxLength: 1024,
        ref: (e) => {
            Internal_updateInputValue(txt, e);
        },
        onChange: (ev) => {
            dispatch(new Msg(16, [key, ev.target.value]));
        },
    })], react.createElement("div", {
        className: "control",
    }, ...children_4))];
    return react.createElement("div", {
        className: "field",
    }, ...children_6);
}

export function singleSlipEl(dispatch, settings, status, qwIdx, slip, nextQwPartIdx, isReadOnly, isFromMultislip) {
    const key = new QwKey(-1, qwIdx);
    const children_26 = toList(delay(() => {
        let children_12;
        return append(singleton((children_12 = toList(delay(() => {
            let children_2, props_2, value;
            return append(singleton((children_2 = [react.createElement("label", {
                className: "label",
            }, "Points"), (props_2 = [new HTMLAttr(65, ["input"]), ["style", {
                width: "80px",
            }], new HTMLAttr(159, ["number"]), new HTMLAttr(79, [isReadOnly]), (value = toString_1(slip.Points), ["ref", (e) => {
                Internal_updateInputValue(value, e);
            }]), new DOMAttr(9, [(ev) => {
                dispatch(new Msg(17, [key, ev.target.value]));
            }])], react.createElement("input", keyValueList(props_2, 1)))], react.createElement("div", {
                className: "control",
            }, ...children_2))), delay(() => {
                let children_6, props_8, value_1;
                return append(singleton((children_6 = [react.createElement("label", {
                    className: "label",
                }, "Jeopardy"), (props_8 = [new HTMLAttr(65, ["input"]), ["style", {
                    width: "80px",
                }], new HTMLAttr(159, ["number"]), new HTMLAttr(79, [isReadOnly]), (value_1 = toString(slip.JeopardyPoints), ["ref", (e_1) => {
                    Internal_updateInputValue(value_1, e_1);
                }]), new DOMAttr(9, [(ev_1) => {
                    dispatch(new Msg(18, [key, ev_1.target.value]));
                }])], react.createElement("input", keyValueList(props_8, 1)))], react.createElement("div", {
                    className: "control",
                }, ...children_6))), delay(() => {
                    let children_8;
                    return append(singleton((children_8 = [react.createElement("input", {
                        type: "checkbox",
                        checked: slip.WithChoice,
                        disabled: isReadOnly,
                        onChange: (ev_2) => {
                            dispatch(new Msg(19, [key, ev_2.target.checked]));
                        },
                    }), " with choice"], react.createElement("label", {
                        className: "checkbox",
                    }, ...children_8))), delay(() => {
                        let children_10;
                        return !isFromMultislip ? singleton((children_10 = [react.createElement("input", {
                            type: "checkbox",
                            checked: slip.EndOfTour,
                            disabled: isReadOnly,
                            onChange: (ev_3) => {
                                dispatch(new Msg(20, [key, ev_3.target.checked]));
                            },
                        }), " end of tour"], react.createElement("label", {
                            className: "checkbox",
                        }, ...children_10))) : empty_1();
                    }));
                }));
            }));
        })), react.createElement("div", {
            className: "field is-grouped",
        }, ...children_12))), delay(() => {
            let matchValue, children_16;
            return append((matchValue = slip.Question, (matchValue.tag === 1) ? singleton((children_16 = toList(delay(() => append(singleton(react.createElement("label", {
                className: "label",
            }, "Questions Text")), delay(() => collect((matchValue_1) => {
                let arg;
                const idx = matchValue_1[0] | 0;
                return singleton(qwInput(dispatch, (arg = ((idx + 1) | 0), toText(printf("Question part %i"))(arg)), matchValue_1[1], key, idx, (idx < nextQwPartIdx) ? true : !equals(status, new TourStatus(0, []))));
            }, indexed(matchValue.fields[0])))))), react.createElement("div", {
                className: "field",
            }, ...children_16))) : singleton(qwTextArea(dispatch, key, matchValue.fields[0], isReadOnly))), delay(() => append(mediaEl(settings.MediaHost, slip.QuestionMedia, false), delay(() => append(singleton(react.createElement("br", {})), delay(() => {
                let matchValue_2, children_24, children_22;
                return append((matchValue_2 = slip.Answer, (matchValue_2.tag === 1) ? singleton((children_24 = [react.createElement("strong", {}, "Answer"), (children_22 = toList(delay(() => map((ch) => {
                    const children_20 = toList(delay(() => append(singleton(ch.Text), delay(() => (ch.IsCorrect ? singleton(Fa_i(singleton_1(new Fa_IconOption(11, ["fas fa-check"])), [])) : empty_1())))));
                    return react.createElement("li", {}, ...children_20);
                }, matchValue_2.fields[0]))), react.createElement("ul", {}, ...children_22))], react.createElement("div", {
                    className: "content",
                }, ...children_24))) : singleton(awTextArea(dispatch, key, matchValue_2.fields[0], isReadOnly))), delay(() => append(singleton(react.createElement("br", {})), delay(() => append(singleton(cmtTextArea(dispatch, key, slip.Comment, isReadOnly)), delay(() => mediaEl(settings.MediaHost, slip.AnswerMedia, false)))))));
            }))))));
        }));
    }));
    return react.createElement("div", {}, ...children_26);
}

export function multipleSlipEl(dispatch, settings, status, name, slips, nextQwIdx, nextQwPartIdx, isReadOnly) {
    let children_2, props_22, children_18, children_16, children_8, children_6, children_14, children_12;
    const children_20 = [(children_2 = [react.createElement("label", {
        className: "label",
    }, "Tour Name"), react.createElement("input", {
        className: "input",
        type: "text",
        disabled: isReadOnly,
        ref: (e) => {
            Internal_updateInputValue(name, e);
        },
        onChange: (ev) => {
            dispatch(new Msg(12, [ev.target.value]));
        },
    })], react.createElement("div", {
        className: "control",
    }, ...children_2)), react.createElement("br", {}), (props_22 = [new HTMLAttr(65, ["table-container"]), ["style", {
        width: "800px",
    }]], (children_18 = [(children_16 = [(children_8 = [(children_6 = toList(delay(() => map((n) => {
        const children_4 = [toText(printf("Question %i"))(n)];
        return react.createElement("th", {}, ...children_4);
    }, rangeDouble(1, 1, length(slips))))), react.createElement("tr", {}, ...children_6))], react.createElement("thead", {}, ...children_8)), (children_14 = [(children_12 = toList(delay(() => collect((matchValue) => {
        let props_14, children_10;
        const idx = matchValue[0] | 0;
        return singleton((props_14 = [Helpers_classList([["has-background-success", idx === nextQwIdx]])], (children_10 = [singleSlipEl(dispatch, settings, status, idx, matchValue[1], 0, isReadOnly ? true : (idx < nextQwIdx), true)], react.createElement("td", keyValueList(props_14, 1), ...children_10))));
    }, indexed(slips)))), react.createElement("tr", {}, ...children_12))], react.createElement("tbody", {}, ...children_14))], react.createElement("table", {
        className: "table",
    }, ...children_16))], react.createElement("div", keyValueList(props_22, 1), ...children_18)))];
    return react.createElement("div", {}, ...children_20);
}

export function secondsLeftToString(sec) {
    let copyOfStruct;
    if (sec > 10) {
        return ((copyOfStruct = (sec - 10), int32ToString(copyOfStruct))) + " + 10";
    }
    else {
        return int32ToString(sec);
    }
}

export function qwView(dispatch, user, settings, tour, timeDiff, isReadOnly, isLoading, isLastQw) {
    const children_16 = toList(delay(() => {
        let children_12;
        return append(singleton((children_12 = toList(delay(() => {
            let children_2;
            return append(singleton((children_2 = [react.createElement("label", {
                className: "label is-large",
            }, "#"), react.createElement("input", {
                className: "input is-large",
                type: "text",
                disabled: isReadOnly,
                ref: (e) => {
                    Internal_updateInputValue(tour.Name, e);
                },
                onChange: (ev) => {
                    dispatch(new Msg(10, [ev.target.value]));
                },
            })], react.createElement("div", {
                className: "control",
            }, ...children_2))), delay(() => {
                let children_6, props_6, props_8, props_16, children_10, props_14, value_1;
                const matchValue_1 = AdminModels_TourControlCard__SecondsLeft_7F9DDECF(tour, serverTime(timeDiff)) | 0;
                let matchResult;
                if (tour.Status.tag === 1) {
                    if (matchValue_1 > 0) {
                        matchResult = 0;
                    }
                    else {
                        matchResult = 1;
                    }
                }
                else {
                    matchResult = 1;
                }
                switch (matchResult) {
                    case 0: {
                        const sec_1 = matchValue_1 | 0;
                        return singleton((children_6 = [(props_6 = [Helpers_classList([["label", true], ["is-large", true], ["has-text-danger", sec_1 <= 10]])], react.createElement("label", keyValueList(props_6, 1), "Seconds Left")), (props_8 = [Helpers_classList([["input", true], ["is-large", true], ["has-text-danger", sec_1 <= 10]]), new HTMLAttr(159, ["text"]), new HTMLAttr(79, [true]), new HTMLAttr(161, [secondsLeftToString(sec_1)])], react.createElement("input", keyValueList(props_8, 1)))], react.createElement("div", {
                            className: "control",
                        }, ...children_6)));
                    }
                    default:
                        return singleton((props_16 = [new HTMLAttr(65, ["control"]), ["style", {
                            width: "min-content",
                        }]], (children_10 = [react.createElement("label", {
                            className: "label is-large",
                        }, "Seconds"), (props_14 = [new HTMLAttr(65, ["input is-large"]), new HTMLAttr(159, ["number"]), new HTMLAttr(79, [isReadOnly]), (value_1 = int32ToString(tour.Seconds), ["ref", (e_1) => {
                            Internal_updateInputValue(value_1, e_1);
                        }]), new DOMAttr(9, [(ev_1) => {
                            dispatch(new Msg(11, [ev_1.target.value]));
                        }])], react.createElement("input", keyValueList(props_14, 1)))], react.createElement("div", keyValueList(props_16, 1), ...children_10))));
                }
            }));
        })), react.createElement("div", {
            className: "field is-grouped",
        }, ...children_12))), delay(() => {
            let matchValue_3, matchValue_4, arg, arg_1;
            const ctrlBtn = (msg, caption) => react.createElement("button", {
                className: "button is-large is-fullwidth",
                disabled: isLoading,
                onClick: (_arg) => {
                    dispatch(msg);
                },
            }, caption);
            return append((matchValue_3 = tour.Status, (matchValue_4 = (AdminModels_TourControlCard__SecondsLeft_7F9DDECF(tour, serverTime(timeDiff)) | 0), (matchValue_3.tag === 1) ? ((matchValue_4 > 0) ? singleton(ctrlBtn(new Msg(27, []), "Reset Countdown")) : singleton(ctrlBtn(new Msg(28, []), "Show answer"))) : ((matchValue_3.tag === 2) ? (isLastQw ? singleton(ctrlBtn(new Msg(3, [toString(new QuizStatus(2, []))]), "Finish")) : singleton(ctrlBtn(new Msg(29, []), "Next Slip"))) : (AdminModels_TourControlCard__get_NeedToDisplayMedia(tour) ? singleton(ctrlBtn(new Msg(23, []), "Show Media")) : (AdminModels_TourControlCard__get_NeedToDisplayQuestion(tour) ? singleton(ctrlBtn(new Msg(24, []), "Show Question")) : (AdminModels_TourControlCard__get_IsReadyForCountdown(tour) ? singleton(ctrlBtn(new Msg(25, []), "Start Countdown")) : (AdminModels_TourControlCard__get_IsSingleMultipart(tour) ? singleton(ctrlBtn(new Msg(22, []), (arg = ((tour.QwPartIdx + 1) | 0), toText(printf("Show Question Part %i"))(arg)))) : singleton(ctrlBtn(new Msg(21, []), (arg_1 = ((tour.QwIdx + 1) | 0), toText(printf("Show Question %i"))(arg_1))))))))))), delay(() => append(singleton(react.createElement("hr", {
                className: "has-background-grey",
            })), delay(() => {
                const matchValue_6 = tour.Slip;
                return (matchValue_6.tag === 1) ? singleton(multipleSlipEl(dispatch, settings, tour.Status, matchValue_6.fields[0], matchValue_6.fields[1], tour.QwIdx, tour.QwPartIdx, isReadOnly)) : singleton(singleSlipEl(dispatch, settings, tour.Status, 0, matchValue_6.fields[0], tour.QwPartIdx, isReadOnly, false));
            }))));
        }));
    }));
    return react.createElement("div", {}, ...children_16);
}

